import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import { createProvider } from "./vue-apollo";

import BootstrapVue from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VueMeta from 'vue-meta';
Vue.use(VueMeta);
Vue.use(BootstrapVue);

import VueBootstrapTypeahead from "vue-bootstrap-typeahead";
import moment from "moment";

Vue.prototype.moment = moment;
// Don't forget to include the Bootstrap CSS/SCSS files!
import "bootstrap/scss/bootstrap.scss";

// Global registration
Vue.component("vue-bootstrap-typeahead", VueBootstrapTypeahead);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  apolloProvider: createProvider(),
  render: h => h(App)
}).$mount("#app");
